import { createStore } from "vuex";
import axios from "axios";
import { modules, pristineState, rootState } from "./pristine.js";
import { clearStoredSession } from "../utils/session";
const BaseUrl = process.env.VUE_APP_BASE_URL;
export default createStore({
  modules,
  state: rootState,
  getters: {
    isLoggedIn(state) {
      return state.isLoggedIn;
    },
    // isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
  },
  mutations: {
    login(state) {
      state.isLoggedIn = true;
    },
    logout(state) {
      state.isLoggedIn = false;
    },
    // Puts every module back to the state it had at boot. Each module declares its
    // state as a factory, so this is a genuine rebuild rather than a hand-maintained
    // list of fields to blank - a module added later is covered without touching this.
    resetSession(state) {
      Object.assign(state, pristineState());
    },
    SET_counters(state, counters) {
      state.counters = counters;
    },
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, { token, user }) {
      state.status = "success";
      state.token = token;
      state.user = user;
    },
    auth_error(state) {
      state.status = "error";
    },
    // logout(state) {
    //   state.status = "";
    //   state.token = "";
    //   state.user = "";
    // },

    SET_error(state) {
      state.error = "Invalid UserName or password!";
      // return false;
    },
  },
  actions: {
    login(context) {
      context.commit('login'); //commit will call mutation name
    },
    // Ends the session but leaves the store alone; emptying it is the last step of
    // src/utils/signOut.js, once nothing is left rendering the old user's data.
    logout(context) {
      clearStoredSession();
      context.commit('logout'); //commit will call mutation name
    },
    getCounters: async ({ commit }) => {
      await axios
        .get(`${BaseUrl}/api/Counter`)
        .then(function (response) {
          commit("SET_counters", response.data.result);
        })
        .catch((error) => console.log(error));
    },
  },
});
